import React, { useEffect, useState } from "react";
import { Card, Button, CardBody } from "reactstrap";

import { Network, Urls } from "../../apiConfiguration";
import { showErrorMessage } from "../../components";
import { useAuth, useLoader } from "../../hooks";
import { getScreenPermissions } from "../../utility/Utils";

import FormModal from "./FormModal";
import Table from "./Table";

const OfficeLocations = () => {
    const [officeLocations, setOfficeLocations] = useState([]);
    const [show, setShow] = useState(false);
    const [apiCall, setApiCall] = useState(false);

    // NEW: control modal mode + selected row
    const [mode, setMode] = useState("Add"); // "Add" | "Edit"
    const [selected, setSelected] = useState(null);

    const { setLoading } = useLoader();
    const { user } = useAuth();
    const permissions = getScreenPermissions(user?.permissions, "office_locations");

    const getOfficeLocations = async () => {
        setLoading(true);
        const response = await Network.get(Urls.getOfficeLocations);
        setLoading(false);

        if (!response.ok) return showErrorMessage(response.data.message);

        setOfficeLocations(response.data.office_locations || []);
    };

    useEffect(() => {
        getOfficeLocations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall]);

    const handleAdd = () => {
        setMode("Add");
        setSelected(null);
        setShow(true);
    };

    const handleEdit = (row) => {
        setMode("Edit");
        setSelected(row);
        setShow(true);
    };

    return (
        <>
            {/*<div className="text-end w-100 mb-2">*/}
            {/*    <Button onClick={handleAdd} color="primary">*/}
            {/*        Add office location*/}
            {/*    </Button>*/}
            {/*</div>*/}


            <FormModal
                show={show}
                setShow={setShow}
                mode={mode}
                initialData={selected}
                setCheck={setApiCall}
            />

            <Card>
                <CardBody>
                    <Table
                        data={officeLocations}
                        permissions={permissions}
                        onEdit={handleEdit}      // NEW
                        setApiCall={setApiCall}  // for delete refresh
                    />
                </CardBody>
            </Card>
        </>
    );
};

export default OfficeLocations;
